import { render, staticRenderFns } from "./baggage_modal.vue?vue&type=template&id=700026d9&scoped=true&"
import script from "./baggage_modal.vue?vue&type=script&lang=js&"
export * from "./baggage_modal.vue?vue&type=script&lang=js&"
import style0 from "./baggage_modal.vue?vue&type=style&index=0&id=700026d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700026d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260806104014/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('700026d9')) {
      api.createRecord('700026d9', component.options)
    } else {
      api.reload('700026d9', component.options)
    }
    module.hot.accept("./baggage_modal.vue?vue&type=template&id=700026d9&scoped=true&", function () {
      api.rerender('700026d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/internal/baggage_modal.vue"
export default component.exports